import React, { useState, useEffect, useCallback } from 'react';
import CustomerList from './CustomerList';
import UserList from './UserList';
import ApolloProviderWithAdminAuth from '../../../services/ApolloProviderWithAdminAuth.jsx';
import Publications from './Publications';
import EtlImport from './EtlImport';
import Analytics from './Analytics';
import Settings from '../Settings';
import { useMeQuery } from '../../../services/authContext';

const VALID_TAB_KEYS = ['customers', 'users', 'publications', 'etl', 'analytics', 'settings'];
const DEFAULT_TAB = 'customers';

function readTabFromHash() {
  const hash = typeof window !== 'undefined' ? window.location.hash.replace(/^#/, '') : '';
  return VALID_TAB_KEYS.includes(hash) ? hash : DEFAULT_TAB;
}

export default function AdminScreen() {
  const [tab, setTab] = useState(readTabFromHash);
  const { isAdmin, isDeveloper } = useMeQuery();

  useEffect(() => {
    const onHashChange = () => setTab(readTabFromHash());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const selectTab = useCallback((key) => {
    if (window.location.hash.replace(/^#/, '') !== key) {
      window.location.hash = key;
    } else {
      setTab(key);
    }
  }, []);

  const TABS = [
    { key: 'customers', label: 'Customers' },
    { key: 'users', label: 'All Users' },
    { key: 'publications', label: 'Publications' },
    { key: 'etl', label: 'Data Import' },
    ...((isAdmin || isDeveloper) ? [{ key: 'analytics', label: 'Analytics' }] : []),
    ...(isDeveloper ? [{ key: 'settings', label: 'Settings' }] : []),
  ];

  return (
        <div style={{ padding: '2rem' }}>
      <h1>Admin Panel</h1>
    <div>
      <div style={{ display: 'flex', borderBottom: '2px solid #eee', marginBottom: 24 }}>
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => selectTab(t.key)}
            style={{
              padding: '12px 24px',
              border: 'none',
              borderBottom: tab === t.key ? '2px solid #0078d4' : '2px solid transparent',
              background: 'none',
              fontWeight: tab === t.key ? 'bold' : 'normal',
              color: tab === t.key ? '#0078d4' : '#333',
              cursor: 'pointer',
              outline: 'none',
              fontSize: 16,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div>
        {tab === 'customers' && (
          <ApolloProviderWithAdminAuth>
            <CustomerList  />
          </ApolloProviderWithAdminAuth>
        )}
        {tab === 'users' && (
          <ApolloProviderWithAdminAuth>
            <UserList isAdmin={isAdmin} />
          </ApolloProviderWithAdminAuth>
        )}
        {tab === 'publications' && (
          <Publications />
        )}
        {tab === 'etl' && (
          <ApolloProviderWithAdminAuth>
            <EtlImport />
          </ApolloProviderWithAdminAuth>
        )}
        {tab === 'analytics' && (isAdmin || isDeveloper) && (
          <Analytics />
        )}
        {tab === 'settings' && isDeveloper && (
          <Settings />
        )}
      </div>
    </div>
    </div>
  );
}
